import { loadDemoDb } from "./demoDb";
import {
  expandDemoInstitutionMenu,
  fetchDemoInstitutionsList,
  injectDemoInstitutionAboutMenuItems,
  isInstitutionParentModule,
} from "./expandDemoInstitutionMenu";

function getInstitutionIdFromSection(section) {
  for (const c of section?.children || []) {
    const key = typeof c?.key === "string" ? c.key.replace(/^\//, "") : "";
    const m = key.match(/^institution\/(\d+)\//);
    if (m) return m[1];
  }
  return null;
}

function applySectionNames(accessGroup, institutions, savedMap) {
  const nameById = new Map(
    (institutions || []).map((k) => [String(k.id), k.name]),
  );
  let fallbackIndex = 0;

  return (accessGroup || []).map((m) => {
    // Demo-only rename: keep prod data untouched.
    if (m?.module_name === "Відділ освіти") {
      return { ...m, module_name: "Управління освіти" };
    }

    const moduleId = String(m?.module_id ?? "");
    const overrideName = savedMap[moduleId];
    if (overrideName) return { ...m, module_name: overrideName };

    if (isInstitutionParentModule(m)) {
      const kgId = getInstitutionIdFromSection(m);
      const fromApi = kgId ? nameById.get(kgId) : null;
      if (fromApi) return { ...m, module_name: fromApi };
      fallbackIndex += 1;
      return { ...m, module_name: `Тестовий заклад ${fallbackIndex}` };
    }
    return m;
  });
}

/**
 * Повне демо-меню: розширити закладуми з API + назви + «Про нас».
 * Лише для демо-користувача; prod не викликає.
 */
export async function buildDemoUserMenu(userInfo) {
  if (!userInfo || !Array.isArray(userInfo.access_group)) return userInfo;

  const institutions = await fetchDemoInstitutionsList();
  let access_group = expandDemoInstitutionMenu(userInfo.access_group, institutions);

  const db = loadDemoDb();
  const savedMap = db?.menuOverrides?.moduleNameById || {};
  access_group = applySectionNames(access_group, institutions, savedMap);
  access_group = access_group.map(injectDemoInstitutionAboutMenuItems);

  return { ...userInfo, access_group };
}
